import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiExclamationTriangle } from 'react-icons/hi2';
import EmergencyPanel from './EmergencyPanel';

const EmergencyButton = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40 bg-orange hover:bg-orange-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 animate-pulse hover:animate-none flex items-center space-x-2"
        aria-label={t('emergency.title')}
      >
        <HiExclamationTriangle className="h-6 w-6" />
        <span className="hidden md:inline font-semibold">{t('emergency.button')}</span>
      </button>

      <EmergencyPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default EmergencyButton;
